import { DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, msurPorcRespuestasMapper, msurTooltipTotalRegistros } from '../commonWidgetsMedicasur'


const GROUP_LABELS_PERSONAL = {
    'serv_lab_trato': 'Recepción',
    'serv_lab_presentacion_personal': 'Presentación Personal',
    'serv_lab_limpieza': 'Limpieza',
    'serv_lab_entrega_rto': 'Entrega Resultados',
    'serv_lab_info_call_center': 'Call Center',
    //'exp_hosp_nutricion_informacion': 'Nutricion'
}



export default {
    title: 'Satisfacción servicios de rehabilitación',
    description: 'Dashboard de servicios de rehabilitación',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General',
                size: [2, 2],
                indicator: 'serv_lab_csat',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_lab_nps',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Por qué seleccionó nuestro Hospital?',
                size: [3, 2],
                indicator: 'serv_lab_motivo_eleccion',
                extraConfigs: {
                    decimals: 0
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGenericByStatus',
                title: 'Porcentaje de respuestas',
                indicator: 'general-respuestas-gauge',
                mapper: msurPorcRespuestasMapper,
                tooltipFormatter: msurTooltipTotalRegistros,
                size: [1, 2],
                url: 'dashboard/status',
                extraIndicatorConfigs: {
                    keyExtract: ['resume'],
                    singleton: true
                },
                extras: {
                    useLcmApi: true,
                    workflowName: 'serv_laboratorio'
                },
                extraConfigs: {
                    showPercentage: true,
                }
            }),
                        
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción',
                key: 'bar-by-question-personal',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_PERSONAL,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PERSONAL).join(","),
                },
                size: [4, 4],
            }),
            



            
            

            {
                title: 'Personal',
                type: 'label',
                size: [4, 1],
                config: { color: '#B7AADC' },
            },


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Trato del personal de admisión',
                size: [1, 2],
                indicator: 'serv_lab_trato',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Orden y limpieza instalaciones',
                size: [1, 2],
                indicator: 'serv_lab_limpieza',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Proceso entrega resultados',
                size: [1, 2],
                indicator: 'serv_lab_entrega_rto',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Información brindada por Call Center',
                size: [1, 2],
                indicator: 'serv_lab_info_call_center',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),




            {
                title: 'Experiencia y Recomendaciones',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },

            /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCount',
                title: 'Comentarios',
                size: [2, 3],
                indicator: 'WORD_COUNT',

            }),
            */
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                size: [4, 2],
                indicator: 'COMMENTS',
                extraConfigs: {
                    maxCommentSize: 120
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                title: 'Clasificación Mande',
                size: [4, 3],
                indicator: 'SENTIMENT'
            }),            
        ]
    },
} as DasboardConfig
